<template>
  <div id="form">
    <!-- Form -->
    <form-wizard
        :title="translations.signup"
        ref="formWizard"
        subtitle=""
        @on-complete="onComplete"
        color="gray"
        :start-index="0"
        error-color="#a94442"
        :next-button-text="translations.next"
        :back-button-text="translations.previous"
        :finish-button-text="translations.finish"
    >

      <!-- First tab -->
      <tab-content
          :title="translations.basicinfo"
          icon="fa fa-user"
          :before-change="validateBasicTab"
      >
        <register-basic-step
            ref="basicStep"
            :model="basicModel"
            :provider-id="providerId"
            :institution-id="institutionId"
            :base_url="base_url"
            :locations="locations"
            :institutions="institutions"
            :picture_url="picture_url"
            :isLanguageForProviderEnabled="isLanguageForProviderEnabled"
            :show_provider_referral_field="show_provider_referral_field"
            :languagesEnabled="languagesEnabled"
            :getPhone="getPhone"
            :getEmail="getEmail"
            :getCpf="getCpf"
            :setProviderId="setProviderId"
            enableReferral
            :showTerms="providerId ? false : true"
            showPassword
            :hideInstitution="hide_institution"
            :cpfMask="cpfMask"
            :cepRequiredValidationDuringSignup="cepRequiredValidationDuringSignup"
            :lang="lang"
        />
      </tab-content>
      <!-- End first tab -->
      <tab-content
          :title="translations.vehicle"
          icon="fa fa-car"
          :before-change="validateSecondTab"
      >
        <register-vehicle-step
            ref="vehicleStep"
            :vehicleModel="vehicleModel"
            :provider-id="providerId"
            :base_url="base_url"
            :treeServiceCategories="treeServiceCategories"
            :carPlateMask="carPlateMask"
        />
      </tab-content>
<!-- End second tab-->
      <tab-content
          :title="translations.bankinginfo"
          icon="fa fa-bank"
          :before-change="validateThirdTab"
          v-if="enableBankStep != '0'"
      >
        <register-bank-step
            ref="bankStep"
            :bankModel="bankModel"
            :provider-id="providerId"
            :base_url="base_url"
            :bank_list="bank_list"
            :account_types="account_types"
            :isGatewayStripe="isGatewayStripe"
            :getBasicData="getBasicData"
            :cpfMask="cpfMask"
            basic-data
            :lang="lang"
        />
      </tab-content>


      <tab-content
          title="PIX"
          icon="fa fa-qrcode"
          :before-change="validateFourthTab"
          v-if="showPixConfig == 1 "
      >
        <register-pix-step
            ref="pixStep"
            :provider-id="providerId"
            :base_url="base_url"
            :pixModel="pixModel"
        />
      </tab-content>

      <tab-content
          :title="translations.docs"
          icon="fa fa-file-text"
          :before-change="validateFifthTab"
      >
        <register-documents-step
            ref="documentsStep"
            :provider-id="providerId"
            :base_url="base_url"
            :documents="documents"
            :documentsModel="documentsModel"
        />
      </tab-content>
      <tab-content :title="tabTitle" icon="fa fa-check">
        <div class="div-signup">
          <div class="div-icon">
            <font-awesome-icon icon="check-circle"/>
          </div>
          <p class="sub-title-page">{{ trans('providerController.thanks')  }}</p>
          <p data-test="success" class="sub-title-page">
            {{ tabText }}
          </p>
        </div>
      </tab-content>

      <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left">
          <wizard-button data-test="left_step" v-if="props.activeTabIndex > 0 && !props.isLastStep"
                         @click.native="props.prevTab()" :style="props.fillButtonStyle">{{ translations.previous }}
          </wizard-button>
        </div>
        <div class="wizard-footer-right">
          <wizard-button data-test="right_step" v-if="!props.isLastStep" @click.native="props.nextTab()"
                         class="wizard-footer-right" :style="props.fillButtonStyle">{{ translations.next }}
          </wizard-button>
        </div>
      </template>
    </form-wizard>
    <!-- End form -->
  </div>
</template>

<script>
import Vue from "vue";
import axios from 'axios';
import Vuetify from 'vuetify';
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Multiselect from 'vue-multiselect';
import {basicModel, vehicleModel, bankModel, pixModel, documentsModel} from "./data/model";
import registerBasicStep from "./registerBasicStep.vue";
import registerVehicleStep from "./registerVehicleStep.vue";
import registerBankStep from "./registerBankStep.vue";
import registerPixStep from "./registerPixStep.vue";
import registerDocumentsStep from "./registerDocumentsStep.vue";
import methods from "./data/methods";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/index.css';
import translations from './data/translations.js'

Vue.use(Vuetify);

Vue.use(VueFormWizard);

export default {
  components: {
    Multiselect,
    DatePicker,
    registerBasicStep,
    registerVehicleStep,
    registerBankStep,
    registerPixStep,
    registerDocumentsStep
  },
  props: {
    base_url: String,
    institution_id: Number | String,
    provider_id: Number | String,
    enableBankStep:Boolean | String,
    hideInstitution: Boolean | String,
    cpfMask: Boolean | String,
    cepRequiredValidationDuringSignup: Boolean | String,
    carPlateMask: Boolean | String,
  },
  vuetify: new Vuetify(),
  data() {
    return {
      translations,
      providerId: null,
      institutionId: null,
      hide_institution: false,
      basicModel,
      vehicleModel,
      bankModel,
      pixModel,
      documentsModel,
      picture_url: null,
      languagesEnabled: [],
      locations: [],
      institutions: [],
      documents: [],
      bank_list: [],
      account_types: [],
      url_steps: [],
      treeServiceCategories: [],
      contextMenuItems: [],
      selectedLocation: null,
      selectedLanguage: null,
      isLanguageForProviderEnabled: false,
      isGatewayStripe: false,
      showPixConfig: 1,
      showBankAccountProviderRegister: 1,
      show_provider_referral_field: 0,
      lang: "",
      tabTitle: this.trans('providerController.signup_done'),
      tabText: this.trans('providerController.signup_sucess'),
      isActive: false,
      disabled: false
    }
  },
  methods,
  mounted() {
    axios.get(this.base_url + '/api/v2/provider/wizard/register_variables', {
      crossDomain: true,
    }).then((response) => {
      // handle success
      var data = response.data.data;
      var vehicleStep = this.$refs.vehicleStep;
      this.locations = data.locations;
      this.bank_list = data.bank_list;
      this.lang = data.lang
      this.documents = data.documents;
      this.institutions = data.institutions;
      var accountTypesArray = data.account_types;
      accountTypesArray.unshift({
        id: null,
				name:this.trans('providerController.select_account_type')
      });
      this.account_types = accountTypesArray;
      this.isGatewayStripe = data.isGatewayStripe;
      this.treeServiceCategories = data.treeServiceCategories;
      data.treeServiceCategories.forEach(element => {
        if (element.nodes)
          vehicleStep.open.push(element);
      });
      this.isLanguageForProviderEnabled = data.isLanguageForProviderEnabled;
      this.languagesEnabled = data.languagesEnabled;
      this.showBankAccountProviderRegister = data.showBankAccountProviderRegister;
      this.showPixConfig = data.showPixConfig;
      this.show_provider_referral_field = data.show_provider_referral_field;
      this.basicModel.first_name = data.basicModel.first_name;
      this.basicModel.last_name = data.basicModel.last_name;
      this.basicModel.birthday = data.basicModel.birthday;
      this.basicModel.email = data.basicModel.email;
      this.basicModel.document = data.basicModel.document;
      this.basicModel.phone = data.basicModel.phone;
      this.basicModel.zipcode = data.basicModel.zipcode;
      this.basicModel.country = data.basicModel.country;
      this.basicModel.address = data.basicModel.address;
      this.basicModel.address_number = data.basicModel.address_number;
      this.basicModel.address_complements = data.basicModel.address_complements;
      this.basicModel.address_neighbour = data.basicModel.address_neighbour;
      this.basicModel.address_city = data.basicModel.address_city;
      this.basicModel.state = data.basicModel.state;
      this.basicModel.login_by = data.basicModel.login_by;

      this.url_steps[0] = '/api/v2/provider/wizard/save_basic_with_institution';
      this.url_steps[1] = '/api/v2/provider/wizard/save_vehicle';
      if (this.showBankAccountProviderRegister == 1 && this.showPixConfig == 1) {
        this.url_steps[2] = '/api/v2/provider/wizard/save_bank';
        this.url_steps[3] = '/api/v2/provider/wizard/save_pix';
        this.url_steps[4] = '/api/v2/provider/wizard/save_document';
      } else if (this.showBankAccountProviderRegister == 1) {
        this.url_steps[2] = '/api/v2/provider/wizard/save_bank';
        this.url_steps[3] = '/api/v2/provider/wizard/save_document';
      } else if (this.showPixConfig == 1) {
        this.url_steps[2] = '/api/v2/provider/wizard/save_pix';
        this.url_steps[3] = '/api/v2/provider/wizard/save_document';
      } else {
        this.url_steps[2] = '/api/v2/provider/wizard/save_document';
      }

      if (this.provider_id) {
        this.providerId = this.provider_id;
        var self = this;
        this.$nextTick(() => {
          self.tabTitle = this.trans('edit_sucess');
          self.tabText = this.trans('update_sucess');
        });
        const url = this.base_url + '/api/v2/provider/wizard/get_provider_data/' + this.providerId;
        this.getProvider(url);
      }
    }).catch((error) => {
      // handle error
    });
  },
  created() {
    if (this.institution_id) {
      this.institutionId = this.institution_id;
    }

    if (this.hideInstitution == '1') {
      this.hide_institution = true;
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./register.css"></style>
<style>
@import "https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900";
@import "https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css";
@import "https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css";
</style>